// extracted by mini-css-extract-plugin
export default {"container":"InlineInfo-module__container-hrxmUQ","icon":"InlineInfo-module__icon-DfIdu0","content":"InlineInfo-module__content-vjBhpo"};